module.exports = __webpack_public_path__ + "img/b_f.7582eb40.jpg";